import { render } from "./BankListVN.vue?vue&type=template&id=1e981b0c"
import script from "./BankListVN.vue?vue&type=script&lang=js"
export * from "./BankListVN.vue?vue&type=script&lang=js"

import "./BankListVN.vue?vue&type=style&index=0&id=1e981b0c&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__